import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Pagination from '../common/Pagination';
import PageHeader from '../common/PageHeader';
import PageState from '../common/PageState';
import { formatPhoneNumber } from '../../utils/format';
import { isTableRowActionTarget } from '../../utils/tableInteraction';
import PhoneRoutingModal from './PhoneRoutingModal';
import { useApi } from '../../hooks/useApi';
import * as T from '../../styles/common/table.styled';

const RoutingBadge = styled(T.Badge).attrs<{ $mode: string }>(props => ({ $tone: props.$mode === "RINGING_GROUP" ? "success" : "info" }))<{ $mode: string }>``;

const PhoneTableArea = T.TableArea;







const getRoutingModeLabel = (mode: string) => {
  switch (mode) {
    case 'IVR':    return 'IVR';
    case 'RINGING_GROUP': return '수신그룹';
    case 'DIRECT': return '직접연결';
    default:       return mode;
  }
};

const getRoutingValue = (item: any) => {
  if (item.routingRelatedName) return item.routingRelatedName;
  switch (item.routingMode) {
    case 'IVR':    return item.ivrInfoId || '-';
    case 'RINGING_GROUP': return item.ringingGroupId || '-';
    case 'DIRECT': return item.phoneId || item.phone_id || '-';
    default:       return '-';
  }
};

const PhoneList = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, loading, error, request: fetchMainPhones } = useApi<any>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPhone, setSelectedPhone] = useState<any>(null);

  useEffect(() => {
    fetchMainPhones({ url: '/main-phone', method: 'GET', params: { pg: currentPage, limit: 10 } })
      .catch(console.error);
  }, [currentPage, fetchMainPhones]);

  const mainPhones = data?.content || [];
  const totalPages   = data?.totalPages    ?? 0;
  const totalElements = data?.totalElements || 0;

  const handleUpdateSuccess = () => {
    fetchMainPhones({ url: '/main-phone', method: 'GET', params: { pg: currentPage, limit: 10 } });
  };

  return (
    <T.PageContainer>
      <PageHeader title="전화번호 관리" count={data && !loading && !error ? totalElements : undefined} />
      <details><summary style={{ cursor: 'pointer', fontSize: 12 }}>대표번호 안내</summary><p style={{ paddingTop: 8, fontSize: 12 }}>대표번호 서비스를 가입하면 070번호로 연결할 수 있습니다.</p></details>


      <PhoneTableArea $stickyActions $minWidth={980}>
        <T.Table>
          <colgroup>
            <col style={{ width: '60px' }} />
            <col style={{ width: '180px' }} />
            <col style={{ width: '140px' }} />
            <col style={{ width: '140px' }} />
            <col style={{ width: '110px' }} />
            <col style={{ width: '110px' }} />
            <col style={{ width: '140px' }} />
          </colgroup>
          <thead>
            <tr>
              <T.Th>No.</T.Th>
              <T.Th>명칭</T.Th>
              <T.Th>전화번호</T.Th>
              <T.Th>
                대표번호
              </T.Th>
              <T.Th>라우팅모드</T.Th>
              <T.Th>연결 대상</T.Th>
              <T.Th>관리</T.Th>
            </tr>
          </thead>
          <tbody>
            {loading || (!data && !error) ? <T.Tr><T.Td colSpan={7}><PageState status="loading" /></T.Td></T.Tr> : error ? <T.Tr><T.Td colSpan={7}><PageState status="error" onRetry={handleUpdateSuccess} /></T.Td></T.Tr> : mainPhones.length > 0 ? mainPhones.map((item: any, index: number) => (
              <T.Tr
                key={item.id}
                $clickable
                onDoubleClick={(event) => {
                  if (isTableRowActionTarget(event.target)) return;
                  setSelectedPhone(item);
                  setIsModalOpen(true);
                }}
              >
                <T.Td>{totalElements - (currentPage - 1) * 10 - index}</T.Td>
                <T.Td style={{ fontWeight: 600 }}>{item.name || '-'}</T.Td>
                <T.Td>{formatPhoneNumber(item.phone)}</T.Td>
                <T.Td>{item.generalPhone ? formatPhoneNumber(item.generalPhone) : '-'}</T.Td>
                <T.Td>
                  <RoutingBadge $mode={item.routingMode}>
                    {getRoutingModeLabel(item.routingMode)}
                  </RoutingBadge>
                </T.Td>
                <T.Td title={String(getRoutingValue(item))}>{getRoutingValue(item)}</T.Td>
                <T.Td>
                  <T.ActionButton onClick={() => { setSelectedPhone(item); setIsModalOpen(true); }}>
                    설정 수정
                  </T.ActionButton>
                </T.Td>
              </T.Tr>
            )) : (
              <T.Tr>
                <T.Td colSpan={7}>
                  <T.NoData>등록된 전화번호가 없습니다.</T.NoData>
                </T.Td>
              </T.Tr>
            )}
          </tbody>
        </T.Table>
      </PhoneTableArea>

      <T.TableFooter>{data && !loading && !error && <T.TotalCount>총 <span>{totalElements}</span>건</T.TotalCount>}<Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setCurrentPage} /></T.TableFooter>

      <PhoneRoutingModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        initialData={selectedPhone}
        onSuccess={handleUpdateSuccess}
      />
    </T.PageContainer>
  );
};

export default PhoneList;
